module.exports = __webpack_public_path__ + "img/vision.25bcd8c1.jpg";